import React from 'react';

import { Navigate, useParams } from 'react-router-dom';

export const BrokenSubscriptionRedirectToView: React.FC = () => {
  const { shopifyCustomerId } = useParams<{ shopifyCustomerId: string }>();
  if (!shopifyCustomerId) {
    return <Navigate to="/broken-subscriptions" replace />;
  }
  return <Navigate to={`/broken-subscriptions/${shopifyCustomerId}/view`} replace />;
};
